import ZooPassLocalStateData from "../Data/ZooPassLocalStateData";
import {PassSelectCardSummary} from "../Components/PanelContents/PassSelectCard";
import {ZooPassOfferingItem} from "../Data/ZooContrib";

export interface ZooPassPricingResult {
    recommended: number | null;
    items: Array<ZooPassOfferingItem | undefined>;
}

export interface GuestStateCalculation {
    next: 5 | 7;
    forced5: null | 0 | 1 | 2 | 3 | 4;
    options: Array<number>
}

export default class ZooPassAnswerAvailabilityUtility {
    
    // private static forces4AdditionalGuests : Array<string> = ["1AF","2AF"];
    // private static forces6AdditionalGuests : Array<string> = ["1BE","2BE"];
    // private static forcesEducationClassCertificate : Array<string> = ["1AF","2AF","1BE","2BE"];
    // private static forcesBehindTheScenesTour : Array<string> = ["1BE","2BE"];
    
    public static BuildSummary(state: ZooPassLocalStateData, membership : ZooPassOfferingItem) : PassSelectCardSummary
    {
        let childrenValue = state.step4FinalValue || 0 as 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | boolean;
        if (childrenValue == 0 && membership.lookup.children === true) {
            childrenValue = true;
        }
        return {
            //Standard
            adults: membership.lookup.adults,
            children: childrenValue,
            guests: membership.lookup.guests,
            parking: membership.lookup.parking,

            //Special
            additional: membership.lookup.additionalGuests,
            education: membership.lookup.education,
            behindScenes: membership.lookup.tour,
        };
    }
    
    public static CalculateGuestOptionAvailability(state: ZooPassLocalStateData) : GuestStateCalculation
    {
        let adults = state.step3Value;
        let children = state.step4FinalValue || 0;
        
        //1 Adult
        if(adults === 1){
            //No Children
            if(children == 0){
                return {
                    next: 5,
                    forced5: null,
                    options: [0,1,2]
                };
            }
            //Has Children
            if(children >= 1){
                return {
                    next: 5,
                    forced5: null,
                    options: [0,1,2,3]
                };
            }
        }
        //2 Adults
        if(adults === 2){
            if(children == 0){
                return {
                    next: 5,
                    forced5: null,
                    options: [0,1,2]
                };
            }
            if(children >= 1){
                return {
                    next: 5,
                    forced5: null,
                    options: [0,1,2,3,4]
                };
            }
        }
        
        //No options found
        return {
            next: 5,
            forced5: null,
            options: [0,1,2]
        };
    }
    
    public static CalculatePassCategory(state: ZooPassLocalStateData, map: Map<string, ZooPassOfferingItem>): ZooPassPricingResult | null 
    {
        const adults = state.step3Value ?? 1;
        const children = (state.step4FinalValue ?? 0) > 0;
        const guests = state.step5Value ?? 0;
        // Parking is now always included; only parking offering codes are returned.

        // 1 adult, no children
        if (adults == 1 && !children && guests == 0) {
            return { recommended: 0, items: [map.get("2IN"), map.get("2I1"), map.get("2I2")] };
        }
        if (adults == 1 && !children && guests == 1) {
            return { recommended: 0, items: [map.get("2I1"), map.get("2CO"), map.get("2I2")] };
        }
        if (adults == 1 && !children && guests == 2) {
            return { recommended: 0, items: [map.get("2I2"), map.get("2D1"), map.get("2AF")] };
        }

        // 2 adults, no children
        if (adults == 2 && !children && guests == 0) {
            return { recommended: 0, items: [map.get("2CO"), map.get("2I2"), map.get("2D1")] };
        }
        if (adults == 2 && !children && guests == 1) {
            return { recommended: 0, items: [map.get("2D1"), map.get("2D2"), map.get("2I2")] };
        }
        if (adults == 2 && !children && guests == 2) {
            return { recommended: 0, items: [map.get("2D2"), map.get("2F3"), map.get("2AF")] };
        }

        // 1 adult, has children
        if (adults == 1 && children && guests == 0) {
            return { recommended: 0, items: [map.get("2AD"), map.get("2SP"), map.get("2FA")] };
        }
        if (adults == 1 && children && guests == 1) {
            return { recommended: 0, items: [map.get("2SP"), map.get("2FA"), map.get("2S1")] };
        }
        if (adults == 1 && children && guests == 2) {
            return { recommended: 0, items: [map.get("2S1"), map.get("2F1"), map.get("2S2")] };
        }
        if (adults == 1 && children && guests == 3) {
            return { recommended: 0, items: [map.get("2S2"), map.get("2F2"), map.get("2AF")] };
        }

        // 2 adults, has children
        if (adults == 2 && children && guests == 0) {
            return { recommended: 0, items: [map.get("2FA"), map.get("2F1"), map.get("2F2")] };
        }
        if (adults == 2 && children && guests == 1) {
            return { recommended: 0, items: [map.get("2F1"), map.get("2F2"), map.get("2AF")] };
        }
        if (adults == 2 && children && guests == 2) {
            return { recommended: 0, items: [map.get("2F2"), map.get("2F3"), map.get("2BE")] };
        }
        if (adults == 2 && children && guests == 3) {
            return { recommended: 0, items: [map.get("2F3"), map.get("2AF"), map.get("2BE")] };
        }
        if (adults == 2 && children && guests == 4) {
            // Affiliate first
            return { recommended: 0, items: [map.get("2AF"), map.get("2BE")] };
        }

        console.warn("Failed to load options!");
        console.log("Adults: ", adults);
        console.log("Children: ", children);
        console.log("Guests: ", guests);
        return null;
    }
    
    
}    